import type Search from 'views/logic/search/Search';
import { INTERNAL_DATA_LAKE_ID } from 'data-lake/preview/storage-types/internal/Constants';

const findDataLakeIdInSearchType = (activeSearch: Search): string => {
  const searchTypes = activeSearch.queries.first().searchTypes?.[0];

  return 'data_lake_id' in searchTypes && searchTypes.data_lake_id ? searchTypes.data_lake_id : INTERNAL_DATA_LAKE_ID;
};

export default findDataLakeIdInSearchType;
